import React from "react";

import {ReactComponent as FrydaLogo} from './../../assets/logo/Fryda_logo.svg';


const ComingSoon = () => {
    return (
        <main className="h-screen bg-white flex justify-center items-center">
            <div className="text-center">
                <FrydaLogo className="mx-auto"/>
                <h1 className="mt-6 text-3xl font-bold tracking-tight text-gray-300 sm:text-5xl">Coming Soon :)</h1>
                <p className="mt-6 text-base leading-7 text-gray-400">
                    We are working hard to make this page available soon. Please check back later.
                </p>
            </div>
        </main>
    );
}

export default ComingSoon;